import React, { createContext, useContext, ReactNode } from 'react';
import { configService } from '../services/configService';

// Types des constantes de configuration
export interface MessagingConfig {
  API_ENDPOINTS: {
    CONVERSATIONS: string;
    MESSAGES: string;
    TOKEN: string;
    SEND: string;
    NOTIFY_MESSAGE: string;
    UPLOAD: string;
    CREATE: string;
    CLIENTS: string;
    USERS: string;
    PROS: string;
  };
  DEFAULT_AVATAR: string;
  CACHE_CONFIG: {
    MESSAGE_CACHE_TTL: number;
    CONVERSATION_CACHE_TTL: number;
    USER_CACHE_TTL: number;
    RESERVATION_CACHE_TTL: number;
    MEDIA_CACHE_TTL: number;
  };
  THROTTLE: {
    CONVERSATION_REFRESH: number;
    MESSAGE_REFRESH: number;
    TOKEN_REFRESH: number;
    DEBOUNCE_DELAY: number;
    TYPING_THROTTLE: number;
  };
}

const defaultConfig: MessagingConfig = {
  API_ENDPOINTS: {
    CONVERSATIONS: configService.getFullApiUrl('/messaging/conversations'),
    MESSAGES: configService.getFullApiUrl('/messaging/conversations'),
    TOKEN: configService.getFullApiUrl('/messaging/token'),
    SEND: configService.getFullApiUrl('/messaging/send'),
    NOTIFY_MESSAGE: configService.getFullApiUrl('/messaging/notify-message'),
    UPLOAD: configService.getFullApiUrl('/upload-url'),
    CREATE: configService.getFullApiUrl('/messaging/create'),
    CLIENTS: configService.getFullApiUrl('/pros'),
    USERS: configService.getFullApiUrl('/users'),
    PROS: configService.getFullApiUrl('/pros')
  },
  DEFAULT_AVATAR: 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png',
  CACHE_CONFIG: {
    MESSAGE_CACHE_TTL: 5 * 60 * 1000, // 5 minutes
    CONVERSATION_CACHE_TTL: 10 * 60 * 1000, // 10 minutes
    USER_CACHE_TTL: 30 * 60 * 1000, // 30 minutes
    RESERVATION_CACHE_TTL: 15 * 60 * 1000, // 15 minutes
    MEDIA_CACHE_TTL: 60 * 60 * 1000 // 1 heure
  },
  THROTTLE: {
    CONVERSATION_REFRESH: 60 * 1000, // 60 secondes
    MESSAGE_REFRESH: 5 * 1000, // 5 secondes
    TOKEN_REFRESH: 60 * 60 * 1000, // 1 heure
    DEBOUNCE_DELAY: 300, // 300ms
    TYPING_THROTTLE: 1000 // 1 seconde entre les indicateurs de frappe
  }
};

// Création du contexte
const MessagingConfigContext = createContext<MessagingConfig>(defaultConfig);

export const MessagingConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <MessagingConfigContext.Provider value={defaultConfig}>
      {children}
    </MessagingConfigContext.Provider>
  );
};

export const useMessagingConfig = () => useContext(MessagingConfigContext);

export default MessagingConfigContext; 